import { IPaginatedLandingContent } from './models/paginated-landing-content'
import { Filter } from './components/paginated-landing-content-app';

export default function matchesAnyAgeHelper(item: IPaginatedLandingContent, filter: Filter[]) {
    let ageResults = item.ages;
    let matchesAge;

    if (!ageResults || ageResults.length == 0) {
        return false
    }
    // if any filters match any age ranges on this item
    for (let i = 0; i < ageResults.length; i++) {
        // if any age result matches
        if (filter.length > 0) {
            for (let n = 0; n < filter.length; n++) {
                if (ageResults[i].toLowerCase() === filter[n].id.toLowerCase()) {
                    matchesAge = true;
                    break;
                }
            }
            if (matchesAge) {
                break;
            }
        }
    }
    return matchesAge;
}